import React from "react";
import { useRegisterStateValue } from "../../RegisterContext";
import { withLocalizeStrings } from "../../../languages/Localize";
import { Box, Flex } from "reflexbox/styled-components";
import styled from "styled-components";
import { Button } from "antd";
import { verificationValidator } from "../../register.validator";
import { Formik } from "formik";
import { Anchor } from "antd";
import VerificationForm from "./VerificationForm";
import { withRouter } from "react-router";
import routes from "../../../config/routes";

const { Link } = Anchor;

const StyledButtonContainer = styled(Box)`
    text-align: center;
`;

const StyledButton = styled(Button)`
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.hover};
    width: 100%;
    height: 50px;
    border: none;
    font-size: inherit;
    text-transform: uppercase;
    &:focus,
    &:hover {
        background: ${({ theme }) => theme.colors.hover};
        color: ${({ theme }) => theme.colors.white};
    }
    &:active {
        background: ${({ theme }) => theme.colors.active};
        color: ${({ theme }) => theme.colors.white};
    }
`;

const StyledHeader = styled(Flex)`
    flex-direction: column;
    align-items: center;
    .divider {
        background: ${({ theme }) => theme.colors.white};
        width: 30px;
        height: 3px;
    }
`;

const StyledHeaderLabel = styled(Box)`
    color: ${({ theme }) => theme.colors.white};
    text-align: center;
`;

const StyledAnchor = styled(Anchor)`
    & {
        background: transparent;
    }
    && .ant-anchor-link-title {
        color: ${({ theme }) => theme.colors.white};
    }
    && .ant-anchor-ink::before {
        display: none;
    }
    && .ant-anchor-link {
        padding: 16px;
        text-align: center;
    }
`;

const VerificationScreen = ({ history, strings }) => {
    const {
        verificationForm,
        setVerificationFormField,
        setVerificationFormValid,
        backScreen,
        verificationFormValid,
        purchaserFormValid,
        attendersFormValid,
        attendersForm,
        purchaserForm
    } = useRegisterStateValue();

    const registerHandler = () => {
        history.push(routes.REGISTER_DONE);
    };

    return (
        <>
            <StyledHeader>
                <StyledHeaderLabel sx={{ fontWeight: "light", fontSize: [5, 6], mt: [3, 4], p: [1, 2] }}>
                    {strings.register.common.VERIFICATION_HEADER}
                </StyledHeaderLabel>
                <div className="divider" />
            </StyledHeader>
            <Box className="required-label first" sx={{ m: [3, 4], px: [1, 2] }}>
                {strings.register.common.VERIFICATION_REQUIRED_LABEL}
            </Box>
            <Formik initialValues={verificationForm} validationSchema={verificationValidator(strings)} isInitialValid={verificationFormValid}>
                {innerPops => <VerificationForm onValidityChange={setVerificationFormValid} onFormChange={setVerificationFormField} {...innerPops} />}
            </Formik>
            <StyledButtonContainer sx={{ marginTop: [3, 4], marginX: [3, 4], marginBottom: 0, px: [1, 2], fontSize: [2, 3] }}>
                <StyledButton disabled={!verificationFormValid || !purchaserFormValid || !attendersFormValid} onClick={registerHandler}>
                    {strings.register.common.VERIFICATION_BUTTON}
                </StyledButton>
            </StyledButtonContainer>
            <StyledAnchor className="link" affix={false} onClick={backScreen}>
                <Link title={strings.register.common.BACK_LABEL} />
            </StyledAnchor>
        </>
    );
};
export default withLocalizeStrings(withRouter(VerificationScreen));
